// components
import {
  Box,
  BoxProps,
  IconButton,
  IconButtonProps,
  styled,
  Tooltip,
  TooltipProps
} from '@mui/material';

export const StyledTopMatchInfoBlock = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  height: '100px',
  width: '100%',
  alignContent: 'space-between',

  '& > *': {
    flex: '0 0 50%'
  },

  [theme.breakpoints.down('medium')]: {
    height: '200px',
    '& > *': {
      flex: '0 0 25%'
    }
  }
}));

export const StyledTopMatchMainContent = styled(Box)<BoxProps>(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(24),
  justifyContent: 'space-between',

  [theme.breakpoints.down('expanded')]: {
    flexDirection: 'column',
    gap: theme.spacing(1)
  }
}));

export const StyledBottomInfoBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),

  '.MuiButtonBase-root': {
    padding: 0
  }
}));

export const StyledIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme }) => ({
    color: theme.palette.text.primary
  })
);

export const StyledIconButtonSmall = styled(StyledIconButton)<IconButtonProps>(
  ({ theme }) => ({
    padding: 0,
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(1)
  })
);

export const StyledCustomWidthBox = styled(Box)<BoxProps>(({ theme }) => ({
  width: '440px',

  [theme.breakpoints.down('expanded')]: {
    width: '100%'
  }
}));

export const StyledMatchInfoTemplateWrapper = styled(Box)<BoxProps>(
  ({ theme }) => ({
    maxWidth: '120px',

    [theme.breakpoints.up('expanded')]: {
      width: '180px'
    },

    [theme.breakpoints.up('extralarge')]: {
      width: '300px'
    }
  })
);

export const StyledCustomMatchDrawerTooltip = styled(Tooltip)<TooltipProps>(
  () => ({
    '& .MuiTooltip-popper .MuiTooltip-tooltip': {
      maxWidth: 440
    }
  })
);
